import SidePanel from "PFComponents/side_panel/side_panel";
import React from "react";

import BookingActivityContextProvider from "../../../parts/providers/booking_activity_context_provider";
import { DetailsSidePanelProps } from "../details_panel_item";
import { EngagementDetailContent } from "./engagement_detail";
import { EngagementDetailHeader } from "./engagement_detail_header";

const EngagementDetailSidePanel = ({
  isOnTop,
  show,
  onClose,
  zIndex,
  isClosing,
  disableEntranceAnimation = false
}: DetailsSidePanelProps) => (
  <SidePanel
    show={show}
    zIndex={zIndex}
    isOnTop={isOnTop}
    isSidePanelClosing={isClosing}
    onClose={onClose}
    title={<EngagementDetailHeader />}
    disableEntranceAnimation={disableEntranceAnimation}
  >
    <EngagementDetailContent />
  </SidePanel>
);

export const EngagementSidePanelWrapper = React.memo((props: DetailsSidePanelProps) => (
  <BookingActivityContextProvider id={props.show ? (props.data?.id as number | undefined) : undefined}>
    <EngagementDetailSidePanel {...props} />
  </BookingActivityContextProvider>
));

EngagementSidePanelWrapper.displayName = "EngagementSidePanelWrapper";
